import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Component } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { getClosestScrollElement, getScrollDirection, getWindowSize, getElementSize } from './utils';

// TODO: delegate Viewport measuring to a store when multiple components measure window
var Viewport = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Viewport, _Component);

  function Viewport() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "firstResizeEvent", true);

    _defineProperty(_assertThisInitialized(_this), "state", {
      width: 0,
      height: 0,
      scrollWidth: 0,
      scrollHeight: 0,
      scrollX: 0,
      scrollY: 0,
      scrollXDirection: null,
      scrollYDirection: null
    });

    _defineProperty(_assertThisInitialized(_this), "getScroll", function () {
      var scrollX = _this.isWindow ? window.pageXOffset : _this.scrollElement.scrollLeft;
      var scrollY = _this.isWindow ? window.pageYOffset : _this.scrollElement.scrollTop;
      var scrollState = {
        scrollX: scrollX,
        scrollY: scrollY,
        scrollXDirection: getScrollDirection('x', _this.lastScrollX, scrollX),
        scrollYDirection: getScrollDirection('y', _this.lastScrollY, scrollY)
      };
      return scrollState;
    });

    _defineProperty(_assertThisInitialized(_this), "updateScroll", function () {
      var scrollState = _this.getScroll();

      if (_this.lastScrollX !== scrollState.scrollX || _this.lastScrollY !== scrollState.scrollY) {
        if (_this.props.updateOnScroll) {
          _this.setState(scrollState);
        }

        if (_this.props.onScroll) {
          _this.props.onScroll(scrollState);
        }
      }

      _this.lastScrollX = scrollState.scrollX;
      _this.lastScrollY = scrollState.scrollY;
    });

    _defineProperty(_assertThisInitialized(_this), "getSize", function () {
      return _this.isWindow ? getWindowSize() : getElementSize(_this.scrollElement);
    });

    _defineProperty(_assertThisInitialized(_this), "updateSize", function () {
      var sizeState = _this.getSize();

      if (_this.props.updateOnResize) {
        _this.setState(sizeState);
      }

      if (_this.props.onResize) {
        _this.props.onResize(sizeState);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setRef", function (innerRef) {
      if (typeof innerRef === 'function') {
        return function (node) {
          if (!_this.node) {
            _this.node = node;
          }

          innerRef(node);
        };
      } else {
        if (!_this.node) {
          _this.node = innerRef;
        }
      }
    });

    return _this;
  }

  var _proto = Viewport.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.scrollElement = getClosestScrollElement(this.node);
    this.isWindow = this.scrollElement === window;

    if (this.props.updateOnScroll || this.props.onScroll) {
      this.scrollElement.addEventListener('scroll', this.updateScroll, {
        passive: true
      });
    }

    this.updateScroll();

    if (this.props.updateOnResize || this.props.onResize) {
      if (this.isWindow) {
        window.addEventListener('resize', this.updateSize);
      } else {
        this.resizeObserver = new ResizeObserver(function () {
          if (_this2.firstResizeEvent) {
            _this2.firstResizeEvent = false;
          } else {
            _this2.updateSize();
          }
        });
        this.resizeObserver.observe(this.scrollElement);
      }
    }

    this.updateSize();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.updateOnScroll || this.props.onScroll) {
      this.scrollElement.removeEventListener('scroll', this.updateScroll, {
        passive: true
      });
    }

    if (this.props.updateOnResize || this.props.onResize) {
      if (this.isWindow) {
        window.removeEventListener('resize', this.updateSize);
      } else {
        this.resizeObserver.disconnect();
      }
    }
  };

  _proto.render = function render() {
    return this.props.children(_objectSpread({
      ref: this.setRef,
      getScroll: this.getScroll,
      getSize: this.getSize
    }, this.state));
  };

  return Viewport;
}(Component);

_defineProperty(Viewport, "defaultProps", {
  updateOnScroll: true,
  updateOnResize: true
});

export default Viewport;